export default "__VITE_ASSET__CqKBcaIC__"